import { ChevronLeft, Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { ReactComponent as Logo } from "../img/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import SearchInput from "./SearchInput";

export function NavbarWithoutLogo({ label }) {
  return (
    <nav className="fixed top-0 left-0 w-full flex bg-white shadow-md p-4 items-center justify-center z-50">
      <div className="fixed left-10">
        <Link to={"/"}>
          <IconButton aria-label="close">
            <Close />
          </IconButton>
        </Link>
      </div>
      <h1 className="font-bold">{label}</h1>
    </nav>
  );
}

export function NavbarWithLogo() {
  const navigate = useNavigate();
  const back = () => {
    navigate("/");
  };

  return (
    <nav className="fixed bg-white left-0 top-0 right-0 px-5 py-3 z-50 shadow-sm border-b">
      <div className="flex justify-between items-center">
        <div className="md:hidden">
          <IconButton onClick={back}>
            <ChevronLeft />
          </IconButton>
        </div>
        <div className="hidden md:block">
          <Link to={"/"}>
            <Logo />
          </Link>
        </div>
        <form className="relative">
          <SearchInput />
        </form>
      </div>
    </nav>
  );
}
